(() => {
  const DIAMOND_ID = "47048331886844";
  const handleDiamondAddToCart = async (event) => {
    const diamond = event?.detail?.diamond;

    if (!diamond) {
      console.error("Diamond detail is missing");
      return;
    }

    const stockNumber = diamond?.stockNumber;
    const diamondId = diamond?.id;
    const clarity = diamond?.clarity;
    const color = diamond?.color?.color;
    const price = diamond?.price?.totalPrice * 100;
    const carat = diamond?.carat;
    const shape = diamond?.shape;
    const cut = diamond?.cut;

    const name = `${shape}, ${carat} Ct, ${color}, ${clarity}, ${cut} Cut Diamond`;

    const formData = new FormData();
    formData.append("properties[_stockNumber]", stockNumber);
    formData.append("properties[_diamondId]", diamondId);
    formData.append("properties[_clarity]", clarity);
    formData.append("properties[_carat]", carat);
    formData.append("properties[_color]", color);
    formData.append("properties[_shape]", shape);
    formData.append("properties[_price]", price);
    formData.append("properties[_name]", name);
    formData.append("properties[_cut]", cut);
    formData.append("id", DIAMOND_ID);
    formData.append("quantity", 1);

    try {
      const event = new CustomEvent("custom:addToCart", {
        detail: formData,
      });

      document.dispatchEvent(event);

      return;
    } catch (error) {
      console.error("some error while sending form:", error);
    }
  };

  window.addEventListener("ds.addtocart", handleDiamondAddToCart);
})();
